import { render, staticRenderFns } from "./AccountHolderHoldsAlert.vue?vue&type=template&id=9417d248&scoped=true"
import script from "./AccountHolderHoldsAlert.vue?vue&type=script&lang=ts"
export * from "./AccountHolderHoldsAlert.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderHoldsAlert.vue?vue&type=style&index=0&id=9417d248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9417d248",
  null
  
)

export default component.exports